const IconChevronUp = (): JSX.Element => {
  return (
    <>
      <path
        fill="currentColor"
        d="M23.3,18.7c-0.7,0.7-1.7,0.7-2.4,0L12,9.8l-8.9,8.9c-0.7,0.7-1.7,0.7-2.4,0S0,17,0.7,16.3l10-10  c0.7-0.7,1.7-0.7,2.4,0l10,10C24,17,24,18.1,23.3,18.7z"
      />
    </>
  );
};

export default IconChevronUp;
